import * as React from 'react';

import { Form, Radio, Space as AntSpace } from 'antd';
import { Space, Text, Checkbox } from 'farmhub-ui-core';
import styled from 'styled-components';

import { NameText } from 'components';
import { ENTITY_REPORT_TYPE_VALUE } from 'utils';

const CardWrapper = styled.div`
  display: flex;
`;

const CardContent = styled.div`
  width: 90%;
  margin-bottom: 20px;
`;

const CardTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CardInput = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrapSwitch = styled.div`
  width: 70px;
  text-align: end;
`;

interface NotifyComponentProps {
  feature: any;
  form: any;
  onSetBodyUpdate: (e: any) => void;
  typeReport: number | undefined;
}

export const ReportFeature = ({
  feature,
  form,
  onSetBodyUpdate,
  typeReport,
}: NotifyComponentProps): JSX.Element => {
  const onChange = (type: number, checked: boolean) => {
    form.setFieldsValue({ [`option${feature.type}.${type}`]: checked });
  };

  const onRadioGroupChange = (value: number) => {
    form.setFieldsValue({ [`option${feature.type}`]: value });
    onSetBodyUpdate({ [`option${feature.type}`]: value });
  };

  return (
    <Form form={form} onValuesChange={onSetBodyUpdate}>
      <CardWrapper>
        <CardContent>
          <CardTitle>
            <Text color="primary" lineHeight="22px" weight="bold">
              {feature.name}
            </Text>
          </CardTitle>
          <Space height={6} />
          <CardInput>
            {typeReport != undefined &&
            typeReport == ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT ? (
              <Form.Item
                name={`option${feature.type}`}
                style={{ marginBottom: '0px' }}
              >
                <Space height={6} />
                <Radio.Group
                  defaultValue={form.getFieldValue([`option${feature.type}`])}
                  onChange={e => onRadioGroupChange(e.target.value)}
                >
                  <AntSpace direction="vertical">
                    {feature.options.map(item => (
                      <Radio value={item.type}>
                        <NameText>{item.name}</NameText>
                      </Radio>
                    ))}
                  </AntSpace>
                </Radio.Group>
              </Form.Item>
            ) : (
              <>
                {feature.options.map(item => (
                  <Form.Item
                    name={`option${feature.type}.${item.type}`}
                    style={{ marginBottom: '0px' }}
                  >
                    <Checkbox
                      checked={form.getFieldValue([
                        `option${feature.type}.${item.type}`,
                      ])}
                      styles={{ margin: '0px !important' }}
                      onChange={e => onChange(item.type, e.target.checked)}
                    >
                      <NameText>{item.name}</NameText>
                    </Checkbox>
                  </Form.Item>
                ))}
              </>
            )}
          </CardInput>
        </CardContent>
        <WrapSwitch>
          {/* <Switch defaultChecked onChange={onChange} /> */}
        </WrapSwitch>
      </CardWrapper>
    </Form>
  );
};
